import {
  IERechnungsInfo,
  IGeschaeftspartnerBeziehung,
  IOrderDetailsInfo,
  isProductCategory as modelUtils_isProductCategory,
} from '@mwe/models';
import { ProductCategoryEnum } from '@mwe/constants';
import { accumulatedCategoryForNewProducts } from '../common/mwe-util';

export const getRelocationFromDetail = (
  relocationDetailsInfo: IOrderDetailsInfo[],
  newAddressCategories: ProductCategoryEnum[],
): IOrderDetailsInfo => {
  const relocationFromDetailsList = relocationDetailsInfo.filter(elem => elem.status === 'Abmeldung');

  const accumulatedCategory = accumulatedCategoryForNewProducts(newAddressCategories);

  const relocationCategoryByAccumulator: Record<number, ProductCategoryEnum> = {
    1: ProductCategoryEnum.STROM,
    2: ProductCategoryEnum.GAS,
    3: ProductCategoryEnum.STROM,
    4: ProductCategoryEnum.FERNWAERME,
    5: ProductCategoryEnum.STROM,
    6: ProductCategoryEnum.GAS,
    7: ProductCategoryEnum.STROM,
  };

  const matchesCategory = (category?: ProductCategoryEnum) =>
    relocationFromDetailsList.find(elem => modelUtils_isProductCategory(elem.category, category));

  const fallbackCategory = [2, 4].includes(accumulatedCategory)
    ? ProductCategoryEnum.STROM
    : [1, 3, 6, 7].includes(accumulatedCategory)
      ? ProductCategoryEnum.GAS
      : undefined;

  const detailsInfo =
    matchesCategory(relocationCategoryByAccumulator[accumulatedCategory]) ??
    (fallbackCategory !== undefined ? matchesCategory(fallbackCategory) : undefined) ??
    matchesCategory(ProductCategoryEnum.NACHTSTROM) ??
    matchesCategory(ProductCategoryEnum.STROMRUECK) ??
    relocationFromDetailsList[0];

  const isStromrueck = modelUtils_isProductCategory(detailsInfo?.category, ProductCategoryEnum.STROMRUECK);
  const bezahlartText = isStromrueck
    ? 'Zahlschein'
    : detailsInfo?.bezahlartText?.toLowerCase() !== 'zahlschein'
      ? detailsInfo?.bezahlartText
      : 'Zahlschein';

  const bezahlartIcon = isStromrueck
    ? 'zahlschein'
    : detailsInfo?.bezahlartText?.toLowerCase() !== 'zahlschein'
      ? 'sepa'
      : detailsInfo?.bezahlartIcon;

  return {
    ...detailsInfo,
    bezahlartIcon,
    bezahlartText,
  };
};

export const updatePartnerDetails = (order: IOrderDetailsInfo, gp: IGeschaeftspartnerBeziehung) => {
  return {
    ...order?.produktDetails?.partner,
    anrede: gp?.physischePerson?.anrede,
    vorname: gp?.physischePerson?.vorname,
    nachname: gp?.physischePerson?.nachname,
    partnerId: order.customerNumber,
    email: gp?.email?.eMail,
    telefon: gp?.telefon?.nummer,
    telefonvorwahl: gp?.telefon?.land,
  };
};

export const getRelocationEmail = (
  relocationDetails: IOrderDetailsInfo,
  eRechnungInfo?: IERechnungsInfo,
  accountEmail?: string,
): string => {
  if (eRechnungInfo?.isERechnungsEmpfaenger) return eRechnungInfo.rechnungEmail;
  if (relocationDetails.produktDetails?.partner?.email) return relocationDetails.produktDetails.partner.email;
  if (relocationDetails.eRechnungInfo?.isERechnungsEmpfaenger) return relocationDetails.eRechnungInfo.rechnungEmail;

  return accountEmail;
};
